import { render, staticRenderFns } from "./BusDepartment.vue?vue&type=template&id=61d0e544&scoped=true"
import script from "./BusDepartment.vue?vue&type=script&lang=js"
export * from "./BusDepartment.vue?vue&type=script&lang=js"
import style0 from "./BusDepartment.vue?vue&type=style&index=0&id=61d0e544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d0e544",
  null
  
)

export default component.exports